var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "./http.js";
import { _getLocale } from "../utils/locale";
const _PlayerApi = class _PlayerApi {
  // In-memory cache object
  static getPlayerDetails() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v1/Player/${id}`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_PlayerApi.cache.has(cacheKey)) {
          return Promise.resolve(_PlayerApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _PlayerApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getPlayerTrophies() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v1/Player/${id}/trophies`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_PlayerApi.cache.has(cacheKey)) {
          return Promise.resolve(_PlayerApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _PlayerApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getPlayerTransfers() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v1/Player/${id}/transfers`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_PlayerApi.cache.has(cacheKey)) {
          return Promise.resolve(_PlayerApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _PlayerApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getPlayerSeasonStats() {
    const abortController = new AbortController();
    return {
      async call(id, seasonId) {
        const locale = _getLocale();
        const endpoint = `/v2/Player/${id}/seasons/${seasonId}/stats`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_PlayerApi.cache.has(cacheKey)) {
          return Promise.resolve(_PlayerApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _PlayerApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getPlayerProfile() {
    const abortController = new AbortController();
    return {
      async call(id) {
        const locale = _getLocale();
        const endpoint = `/v1/Player/${id}/profile`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_PlayerApi.cache.has(cacheKey)) {
          return Promise.resolve(_PlayerApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal
        }).then((response) => {
          _PlayerApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
};
__publicField(_PlayerApi, "cache", /* @__PURE__ */ new Map());
let PlayerApi = _PlayerApi;
var stdin_default = PlayerApi;
export {
  stdin_default as default
};
